import React, { Component } from 'react';
import Slider from "react-slick";
import LoginBox from './LoginBox';
import TrackingBox from './TrackingBox';

const Home = () => {
  function SampleNextArrow({ className, style, onClick }) {
    return (
      <div
        className={`${className} custom-arrow next`}
        style={{ ...style }}
        onClick={onClick}
      >
        <i className="fas fa-chevron-right"></i>
      </div>
    );
  }

  function SamplePrevArrow({ className, style, onClick }) {
    return (
      <div
        className={`${className} custom-arrow prev`}
        style={{ ...style }}
        onClick={onClick}
      >
        <i className="fas fa-chevron-left"></i>
      </div>
    );
  }
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    dots: false
  };
  return (
    <>
      <div className='container-fluid'>
        <Slider {...settings}>
          <div>
            <img src="images/Banner.webp" className='img-fluid' alt="" />
          </div>
          <div>
            <img src="images/Banner1.webp" className='img-fluid' alt="" />
          </div>
          <div>
            <img src="images/Banner2.webp" className='img-fluid' alt="" />
          </div>
        </Slider>
      </div>

      <>
        {/* MAIN SECTION */}
        <section className="main-section">
          <div className="container">
            <div className="row g-4">

              {/* SIDEBAR */}
              <div className="col-lg-3">

                <TrackingBox/>
                <LoginBox/>

                {/* Contact */}
                <div className="contact-card">
                  <div className="contact-title">Contact</div>

                  <div className="contact-item">
                    <div className="contact-icon phone">
                      <i className="fa fa-phone"></i>
                    </div>
                    <a href="tel:01141606842">+91 96672 33072</a>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon email">
                      <i className="fa fa-envelope"></i>
                    </div>
                    <a href="#">oxford_express@yahoo.co.in</a>
                  </div>

                  <div className="contact-item">
                    <div className="contact-icon email">
                      <i className="fa fa-envelope"></i>
                    </div>
                    <a href="#">info@oxfordexp.com</a>
                  </div>
                </div>
              </div>

              {/* CONTENT */}
              <div className="col-lg-9">

                {/* Welcome */}
                <div className="bg-white rounded-3 p-4 mb-4 shadow-sm">

                  <h2 className="section-title">
                    Welcome to <span>Oxford Express Pvt. Ltd.</span>
                  </h2>

                  <p className="welcome-text">
                    Oxford Express Private Limited was incorporated with the main objective of providing premium logistic services to the client demanding quality services. Company is governed by Mr. Mukesh Mittal (Director of the company). Oxford Express recognises that our people, at every level of the company, are our greatest asset. It is their knowledge and expertise which ensures that the rest of the assets - from vehicles to state of the art warehouse management systems - provide the optimum logistics solution for each of our customers.
                  </p>

                  <p className="welcome-text">
                   The company has a team of qualified and trained staff with adequate courier Knowledge and experience to cater the ever-increasing demands of the corporate sector. Our operations are controlled from our New Delhi Regd. Office. well-trained staff & latest electronic systems to handle on an average 4.5 lakhs of packet per month.
                  </p>

                  <a href="/about-us" className="read-more">
                    <i className="fa fa-arrow-right me-1"></i> Read More
                  </a>
                </div>

                {/* Services + News */}
                <div className="row g-4">

                  {/* Services */}
                  <div className="col-md-6">
                    <div className="services-box">
                      <div className="services-box-header">Our Services <span></span></div>

                      <div className="services-box-body">
                        <img
                          src="images/img_services.png"
                          alt="Services"
                          className="services-img"
                        />

                        <ul className="services-list">
                          <li>Oxford Engineering</li>
                          <li>Express Services</li>
                          <li>Domestic Services</li>
                          <li>Time Definite Services</li>
                          <li>Sameday</li>
                          <li>Service Features</li>
                        </ul>
                      </div>

                      <div className="svc-footer">
                        <a href="/services" className="svc-more">
                          <i className="fa fa-arrow-right me-1"></i> Read more...
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* News */}
                  <div className="col-md-6">
                    <div className="news-box">
                      <div className="services-box-header">News Flash <span></span></div>

                      <div className="news-box-body">

                        <div className="news-items">

                          <div className="news-item">
                            <div className="news-dot"></div>
                            <div className="news-item-text">
                              Our mission is to exceed customers' expectations in the transfer of their goods and documents around the world. We deliver value to our customers by providing the most reliable and efficient solutions in distribution and logistics. We lead the industry by instilling pride in our people, creating value for our stakeholders and sharing responsibility for our world.
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

        {/* STATS STRIP */}
        <section className="stats-strip">
          <div className="container">
            <div className="row g-0 text-center">

              <div className="col-6 col-md-3 stat-item py-2">
                <div className="stat-number">4.5L+</div>
                <div className="stat-label">Packets / Month</div>
              </div>

              <div className="col-6 col-md-3 stat-item py-2">
                <div className="stat-number">1000+</div>
                <div className="stat-label">Cities Covered</div>
              </div>

              <div className="col-6 col-md-3 stat-item py-2">
                <div className="stat-number">35+</div>
                <div className="stat-label">Years Experience</div>
              </div>

              <div className="col-6 col-md-3 stat-item py-2">
                <div className="stat-number">10K+</div>
                <div className="stat-label">Happy Clients</div>
              </div>

            </div>
          </div>
        </section>
      </>
    </>
  );
}
export default Home